import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

import './Offers.css';
import Button from '../common/button/Button';
import { Modal } from 'components/common/modal';
import ReadMore from '../common/readMore/ReadMore';

import { closeModal } from 'features/modalSlice';

const Offers = () => {
    const dispatch = useDispatch();

    const { isOffersModalOpen } = useSelector((state) => state.modal);

    const ourOffersList = useSelector(
        (state) => state.miniBookingWidget?.ourOffersList
    );
    const colors = useSelector(
        (state) => state.miniBookingWidget?.data?.colors
    );

    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);

    const commonStyles = {
        backgroundColor: colors?.primaryBackgroundColor,
        color: colors?.primaryTextColor,
    };

    const [activeOfferIndex, setActiveOfferIndex] = useState(0);

    const setVisibleOffer = (step) => {
        if (activeOfferIndex + step < 0) {
            setActiveOfferIndex(ourOffersList.length - 1);
        } else if (activeOfferIndex + step >= ourOffersList.length) {
            setActiveOfferIndex(0);
        } else {
            setActiveOfferIndex(activeOfferIndex + step);
        }
    };

    const title = ourOffersList[activeOfferIndex]?.title;

    const handleModalClose = useCallback(() => {
        dispatch(closeModal({ modalId: 'OffersModal' }));
    }, [dispatch, closeModal]);

    if (!ourOffersList || ourOffersList.length === 0) {
        return null;
    }

    const renderContent = () => {
        return (
            <div>
                <div className="ab-offers-cnt" style={commonStyles}>
                    {ourOffersList.map((offer, index) => {
                        if (index === activeOfferIndex) {
                            return (
                                <div className="ab-offer-cnt" key={index}>
                                    <div className="ab-offer-body">
                                        <ReadMore
                                            className="ab-offer-description"
                                            moreText={Lang?.more}
                                            lessText={Lang?.less}
                                        >
                                            {offer.text}
                                        </ReadMore>
                                        <div className="ab-offer-details">
                                            {offer?.minStay &&
                                                offer?.minStayText && (
                                                    <div className="ab-offer-detail">
                                                        <span>
                                                            {offer.minStay}
                                                        </span>
                                                        <span>
                                                            {offer.minStayText}
                                                        </span>
                                                    </div>
                                                )}

                                            {offer?.stayPeriod &&
                                                offer?.stayPeriodText && (
                                                    <div className="ab-offer-detail">
                                                        <span>
                                                            {offer.stayPeriod}
                                                        </span>
                                                        <span>
                                                            {
                                                                offer.stayPeriodText
                                                            }
                                                        </span>
                                                    </div>
                                                )}

                                            {offer?.mealType &&
                                                offer?.mealTypeText && (
                                                    <div className="ab-offer-detail">
                                                        <span>
                                                            {offer.mealType}
                                                        </span>
                                                        <span>
                                                            {offer.mealTypeText}
                                                        </span>
                                                    </div>
                                                )}

                                            {offer?.price && offer?.priceText && (
                                                <div className="ab-offer-detail">
                                                    <span>{offer.price}</span>
                                                    <span>
                                                        {offer.priceText}
                                                    </span>
                                                </div>
                                            )}
                                        </div>

                                        {offer?.buttonLink &&
                                            offer?.buttonText && (
                                                <a
                                                    className="ab-offer-btn"
                                                    href={offer.buttonLink}
                                                    target="_blanck"
                                                    rel="noopener noreferrer"
                                                    style={commonStyles}
                                                >
                                                    <span>
                                                        {offer.buttonText}
                                                    </span>
                                                </a>
                                            )}
                                    </div>
                                </div>
                            );
                        } else {
                            return null;
                        }
                    })}
                </div>

                {ourOffersList.length > 1 && (
                    <div className="ab-offers-nav-btns">
                        <Button
                            onClick={() => setVisibleOffer(-1)}
                            className="ab-offers-nav-btn--left"
                        >
                            <FaChevronLeft />
                        </Button>
                        <span>
                            {activeOfferIndex + 1} / {ourOffersList.length}
                        </span>
                        <Button
                            onClick={() => setVisibleOffer(1)}
                            className="ab-offers-nav-btn--right"
                        >
                            <FaChevronRight />
                        </Button>
                    </div>
                )}
            </div>
        );
    };

    return (
        <Modal
            className="ab-modal--offers"
            color={colors?.primaryTextColor}
            backgroundColor={colors?.primaryBackgroundColor}
            icon="HiOutlineSpeakerphone"
            isOpen={isOffersModalOpen}
            onClose={handleModalClose}
            onOverlayClick={handleModalClose}
            placement="center"
            renderContent={renderContent}
            styles={{
                closeIcon: { color: colors?.primaryTextColor },
            }}
            title={title}
            variant="secondary"
            width={311}
        />
    );
};

export default Offers;
